import { createContext, PropsWithChildren } from 'react'

import { useTheme } from '@emotion/react'

import { ThemeVariantProvider } from '@cash-design-system/react'
import { FeatureFlagDefaultStringVariant } from '@cash-web/shared-data-access-feature-flags'

type ArcadeFeatureContextType = FeatureFlagDefaultStringVariant | undefined

export const ArcadeFeatureContext = createContext<ArcadeFeatureContextType>('UNASSIGNED')

interface ArcadeFeatureProviderProps {
  isArcadeFeatureEnabled: ArcadeFeatureContextType
}

export const ArcadeFeatureProvider: React.FC<PropsWithChildren<ArcadeFeatureProviderProps>> = ({
  isArcadeFeatureEnabled,
  children,
}) => {
  const theme = useTheme()
  return (
    <ThemeVariantProvider themeVariant={isArcadeFeatureEnabled === 'ENABLED' ? 'monochrome' : theme.themeVariant}>
      <ArcadeFeatureContext.Provider value={isArcadeFeatureEnabled}>{children}</ArcadeFeatureContext.Provider>
    </ThemeVariantProvider>
  )
}
